import { render, staticRenderFns } from "./WorkIconService.vue?vue&type=template&id=6c53e60a"
import script from "./WorkIconService.vue?vue&type=script&lang=js"
export * from "./WorkIconService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports